export enum ProductionOrderState {
  Unknown = -1,
  Deleted = 0,
  Planned = 1,
  Released = 2,
  Reserved = 3,
  Preparing = 4,
  Prepared = 5,
  Delivering = 6,
  Completed = 7,
  Registered = 8,
  PreparingPaused = 9,
  DeliveringPaused = 10,
}
